import { useGSAP } from '@gsap/react';
import { uiSimpleBox } from 'components/BionicUI/CutCorners';
import gsap from 'gsap';
import { cn } from 'lib/utils';
import { FC, useRef, useState } from 'react';

const BPIconBorder: FC<{ animate?: boolean; onAnimComplete?: () => void }> = ({
  animate = false,
  onAnimComplete = () => {},
}) => {
  const animatedEdge = useRef(null);
  const [angle, setAngle] = useState(36);

  useGSAP(() => {
    if (!animate) return;
    const angle = { degrees: 36 };
    gsap
      .timeline({ onComplete: onAnimComplete })
      .set(animatedEdge.current, { autoAlpha: 0 })
      .to(animatedEdge.current, {
        autoAlpha: 1,
        duration: 0.5,
        ease: 'power3.in',
      })
      .to(
        angle,
        {
          degrees: 396,
          duration: 2.5,
          ease: 'power3.inOut',
          onUpdate: () => setAngle(Math.round(angle.degrees)),
        },
        '<'
      )
      .to(
        animatedEdge.current,
        {
          autoAlpha: 0,
          duration: 0.5,
          ease: 'power3.out',
        },
        '>-0.5'
      );
  }, [animate]);

  return (
    <>
      <div
        className={cn(
          'block absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/30 to-white/10',
          uiSimpleBox.border
        )}
      />
      <div
        ref={animatedEdge}
        className={cn(
          'block absolute top-0 left-0 w-full h-full opacity-0 invisible',
          uiSimpleBox.border
        )}
        style={{
          backgroundImage: `conic-gradient(from ${angle}deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 80%, white 100%)`,
        }}
      />
    </>
  );
};

export default BPIconBorder;
